import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "hideable" ]
  static values = { display: { type: String, default: "block" } }

  toggleTargets() {
    this.hideableTargets.forEach((el) => {
      // Use getComputedStyle to detect if element is hidden via CSS or inline styles
      if (window.getComputedStyle(el).display === "none") {
        el.style.display = this.displayValue;
        if (document.querySelector('.sidebar')) {
          document.querySelector('.sidebar').style.display = "flex";
        }
      } else {
        el.style.display = "none";
        if (document.querySelector('.sidebar')) {
          document.querySelector('.sidebar').style.display = "none";
        }
      }
    });
  }
}
